import React, { useMemo } from "react";
import { DataGrid, Column, Editing } from "devextreme-react/data-grid";
import { useDataSource } from "../../../contexts/dataSource";
import { getPropsDataGrid } from "../../../utils/default-props";

interface EarnedLeaveTabProps {
    employeeId: number;
    leaveInfoId: number;
}

interface EmployeeLeaveAccrual {
    id: number;
    employeeId: number;
    leaveInfoId: number;
    earnedDate: Date;
    expiryDate: Date;
    deserved: number;
    used: number;
    remaining: number;
}

interface RowInsertingEvent {
    data: Partial<EmployeeLeaveAccrual>;
    component?: any;
    element?: any;
}

const EarnedLeaveTab: React.FC<EarnedLeaveTabProps> = ({ employeeId, leaveInfoId }) => {
    const { dataSourceHR } = useDataSource();

    const detailDataSource = useMemo(
        () =>
            dataSourceHR({
                key: 'id',
                loadUrl: `/api/EmployeeLeaveAccrual/EmployeeWithLeaveInfoId/${employeeId}/${leaveInfoId}`,
                insertUrl: '/api/EmployeeLeaveAccrual/FormData',
            }),
        [dataSourceHR, employeeId, leaveInfoId]
    );

    if (!employeeId || !leaveInfoId) {
        return <div>Gerekli veriler eksik!</div>;
    }

    const onRowInserting = (e: RowInsertingEvent): void => {
        e.data.employeeId = employeeId;
        e.data.leaveInfoId = leaveInfoId;
    };

    return (
        <DataGrid
            dataSource={detailDataSource}
            repaintChangesOnly={true}
            onRowInserting={onRowInserting}
            {...getPropsDataGrid}
        >
            <Column dataField="earnedDate" caption="Hak Ediş Tarihi" dataType="date" />
            <Column dataField="expiryDate" caption="Son Kullanma Tarihi" dataType="date" />
            <Column dataField="deserved" caption="Hak Edilen" />
            <Column dataField="used" caption="Kullanılan" />
            <Column dataField="remaining" caption="Kalan" />
            <Editing
                mode="popup"
                allowUpdating={true}
                allowDeleting={true}
                useIcons={true}
            />
        </DataGrid>
    );
};

export default EarnedLeaveTab;